<template>
  <asc-dialog
    class="asc-choose-derived-airline-dialog"
    :show-dialog="showDialog"
    :text="title"
    :width="390"
    :on-close="handleClose"
    :primary-available="isPrimaryEnabled"
    :on-primary="handleAccept"
    :on-secondary="handleClose"
    primary-button-text="next"
    secondary-button-text="cancel"
  >
    <template v-if="showDialog">
      <v-container class="px-4 asc-choose-derived-airline-dialog--container">
        <template v-if="displayAirline">
          <asc-autocomplete-selector
            v-model="selectedAirline"
            label="Airline"
            placeholder="Select Airline"
            component-type="single"
            dense
            drop-down-size-matches
            fixed-position
            no-array
            :items="airlines"
            :on-change="handleAirlineChange"
          />
        </template>
        <template v-if="displayPlatform">
          <asc-autocomplete-selector
            v-model="selectedPlatform"
            label="Platform"
            placeholder="Select Platform"
            component-type="single"
            dense
            drop-down-size-matches
            fixed-position
            no-array
            :items="getPlatformsData"
            :on-change="handlePlatformChange"
            :disabled="isPlatformDisabled"
            :class="[displayAirline ? 'top-margin-selector' : null]"
          />
        </template>
      </v-container>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscLabel from '@/components/atoms/AscLabel'
import AscAutocompleteSelector from './AscAutocompleteSelector'
import _ from 'lodash'

export default {
  name: 'AscDerivedParameterChooseAirlineDialog',

  components: {
    AscDialog,
    AscLabel,
    AscAutocompleteSelector,
  },

  mixins: [AscDialogMixin],

  props: {
    title: {
      type: String,
      default: '',
    },
    subText: {
      type: String,
      default: '',
    },
    airlines: {
      type: Array,
      default: () => [],
    },
    mappedAcmfMasterModels: {
      type: Array,
      default: () => [],
    },
    displayAirline: {
      type: Boolean,
      default: false,
    },
    displayPlatform: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      selectedAirline: null,
      selectedAirlineItem: null,
      selectedPlatform: null,
      selectedPlatformItem: null,
    }
  },

  computed: {
    isPrimaryEnabled() {
      if (this.displayPlatform && this.displayAirline)
        return this.selectedAirlineItem && this.selectedPlatformItem
          ? true
          : false
      else if (this.displayPlatform)
        return this.selectedPlatformItem ? true : false
      else return this.selectedAirlineItem ? true : false
    },
    getPlatformsData() {
      var uniquePlatforms = []
      this.mappedAcmfMasterModels
        .filter(item => {
          if (this.displayAirline) {
            return item.airlineId === this.selectedAirlineItem?.airlineId
          } else {
            return item
          }
        })
        .map(item => {
          return {
            text: item.text,
            value: item.value,
            masterModelId: item.masterModelId,
          }
        })
        .filter(function (item) {
          var i = uniquePlatforms.findIndex(x => x.value == item.value)
          if (i <= -1) {
            uniquePlatforms.push({
              text: item.text,
              value: item.value,
              masterModelId: item.masterModelId,
            })
          }
        })
      return uniquePlatforms
    },
    isPlatformDisabled() {
      return this.selectedAirlineItem === null && this.displayAirline
        ? true
        : false
    },
  },
  watch: {
    selectedAirlineItem(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        this.selectedPlatform = null
        this.selectedPlatformItem = null
      }
    },
  },
  methods: {
    handleAccept() {
      const selectedAirline = this.selectedAirlineItem
      const selectedPlatform = this.selectedPlatformItem
      this.selectedAirline = null
      this.selectedAirlineItem = null
      this.selectedPlatform = null
      this.selectedPlatformItem = null
      this.onAccept(selectedAirline, selectedPlatform)
      this.handleClose()
    },

    handleAirlineChange(id, selection, selectionObject) {
      if (selectionObject.length) {
        this.selectedAirlineItem = selectionObject[0]
      }
    },
    handlePlatformChange(id, selection, selectionObject) {
      if (selectionObject.length) {
        this.selectedPlatformItem = selectionObject[0]
      }
    },
  },
}
</script>

<style lang="scss">
.asc-choose-derived-airline-dialog {
  &--container {
    padding-top: 5%;
    height: 300px;

    .asc-autocomplete-selector {
      margin-top: 5%;
    }
  }
  .top-margin-selector {
    margin-top: 15%;
  }
  .asc-dialog {
    .v-card__text {
      padding: 0;
    }
  }
}
</style>
